export const FaqCategory = Object.freeze({
  GENERAL: "General",
  HEART: "Heart",
  CONCIERGE: "Concierge",
  ABOUT: "About",
})  

export default FaqCategory